import { createSlice } from '@reduxjs/toolkit';

import { fetchRecommendedCrossSellDevices } from 'store/common/recommendations/crossSell/actions';
import { RecommendationBlockData } from 'store/common/recommendations/types';

type State = {
  isFetching: boolean;
  isError: boolean;
} & RecommendationBlockData;

const initialState: State = {
  isFetching: false,
  isError: false,
  strategyName: '',
  strategyMessage: '',
  placement: '',
  devices: [],
};

const crossSell = createSlice({
  name: 'crossSell',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRecommendedCrossSellDevices.pending, (state) => {
      state.isFetching = true;
      state.isError = false;
    });
    builder.addCase(fetchRecommendedCrossSellDevices.fulfilled, (state, { payload }) => {
      state.isFetching = false;
      state.isError = false;
      if (payload) {
        state.strategyName = payload.strategyName;
        state.strategyMessage = payload.strategyMessage;
        state.placement = payload.placement;
        state.devices = payload.devices;
      }
    });
    builder.addCase(fetchRecommendedCrossSellDevices.rejected, (state) => {
      state.isFetching = false;
      state.isError = true;
    });
  },
});

export default crossSell.reducer;
